export enum PLATFORM {
  VIZIO = '1217562',
  WINDOWS = '1217556',
  XBOX = '1217569',
  COMCAST = '1217563',
  LG = '1217553',
  OPERA = '1217554',
  NETGEM = '1218181',
  SAMSUNG = '1217555',
  TATASKY = '1217557',
  AIRTEL = '1217561',
  PANASONIC = '1217564',
  ZEASN = '1217566',
  FOXXUM = '1217567',
  COX = '1217568',
  NETRANGE = '1217565',
  ROGERS = '1217570',
  SHAW = '1217571',
  PLATCO = '1217572',
  VIDAA = '1217574'
}

export enum REQUEST_STATUS {
  NONE = 0,
  FETCHING = 1,
  OK = 2,
  FAIL = 3,
}

export enum THUMBNAIL_ORIENTATION {
  PORTRAIT = 0,
  LANDSCAPE = 1,
  MIXED = 2,
}

export enum PLAYLIST_SWITCHING_STRATEGY {
  DEFAULT = 'default',
  CONTINUES = 'continues',
}

export enum ACTIONTYPE {
  VIDEO = 'video',
  CATEGORY = 'category',
  CHILDAPP = 'child-app',
  LIVE = "live"
}

export enum GRIDTYPE {
  GRID = 'grid',
  MLP = 'mlp',
  SEARCH = 'search',
  QUEUE ='queue',
  DEEPLINK = 'deeplink',
  DYNID = 'dynid',
  VIDEOPLAYLIST = 'videoplaylist',
  SIMILAR_VIDEOS = 'similar',
  LIVE = 'live',
  LIVE_SELECTSCREEN = 'live-selectscreen'
}

export enum PLAYERSTATE {
    NONE = 'none',
    INITIALIZING = 'initializing', //setting up the player and source and watiing for loadedmetadata event.
    READY = 'ready', //on loadedmetadata event
    PLAYING = 'playing', // on player state is no
    PAUSED = 'paused',
    FF = 'ff',
    REW = 'rew'
}

export enum DRM_TYPE {
  PLAYREADY = 'playready',
  WIDEVINE = 'widevine'
}

export enum DIALOG_TYPE {
  NETWORK_BOX = 'network', // for network disconnection / connection box with loading icon.
  ALERT = 'alert', // for the use of showing message or allert message with OK button.
  CONFIRM_BOX = 'confirm',
  APP_EXIT_BOX = 'app-exit'
}

export enum DIALOG_BUTTON_ACTION {
  NO = 'no',
  YES = 'yes',
  CLOSE = 'close'
}


